import { Typography } from '@material-ui/core';
import React from 'react';
import { FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton, TwitterIcon, TwitterShareButton } from 'react-share';
import { inIframe } from '../../libs/helpers';

class FundraiseSharer extends React.Component {
  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */
  /* API Call */
  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */

  /* Render Page */
  render() {
    const url = inIframe() ? window.parent.location.href : window.location.href;
    const { classes } = this.props;
    return (
      <div className={classes.sharerCont}>
        <Typography align='center' className={classes.sharerTitle}>
          Help By Sharing
        </Typography>
        <div className='row tmargin-5' style={{ justifyContent: 'center' }}>
          <FacebookShareButton url={url} >
            <FacebookIcon size={32} bgStyle={{ fill: 'transparent' }} iconFillColor='#AEAEAE' />
          </FacebookShareButton>
          <TwitterShareButton url={url}>
            <TwitterIcon size={32} bgStyle={{ fill: 'transparent' }} iconFillColor='#AEAEAE' />
          </TwitterShareButton>
          <LinkedinShareButton url={url}>
            <LinkedinIcon size={32} bgStyle={{ fill: 'transparent' }} iconFillColor='#AEAEAE' />
          </LinkedinShareButton>
        </div>
      </div>
    );
  }
}

export default FundraiseSharer;